import { GridColumnConfig } from '../../../../../models/gridCoumnConfig';

export const fileColumns: GridColumnConfig[] = [
  {
    title: 'Select',
    field: 'select',
    filter: 'text',
    width: "100px",
    searchable: true,
    isGroupable: false,
    isHideColumnMenu: true
  },
  {
    title: 'File Name',
    field: 'fileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Type',
    field: 'fileType',
    filter: 'date',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'date',
    searchable: true,
  },
  {
    title: 'Uploaded By',
    field: 'uploadedByFullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded On',
    field: 'uploadedOnText',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Order',
    field: 'fileOrder',
    filter: 'text',
    searchable: true,
  },
  // {
  //   title: 'File Order',
  //   field: 'fileOrder',
  //   filter: 'text',
  //   editable: true,
  //   editor: 'numeric',
  //   width: '110',
  //   searchable: true,
  // },
];
